import React from "react";
import { ROUTES } from "./routes";

// Lazy load pages for better performance
const Home = React.lazy(() => import("../pages/home/Home"));
const DataDeletionPage = React.lazy(() => import("../pages/legal/DataDeletionPage"));
const UserPrivacyPolicyPage = React.lazy(() => import("../pages/legal/UserPrivacyPolicyPage"));
const ProviderPrivacyPolicyPage = React.lazy(() => import("../pages/legal/ProviderPrivacyPolicyPage"));
const TermsConditionsPage = React.lazy(() => import("../pages/legal/TermsConditionsPage"));
const GetStartedPage = React.lazy(() => import("../pages/get_started/GetStartedPage"));
const HelpCenterPage = React.lazy(() => import("../pages/help/HelpCenterPage"));
const ProvidersPage = React.lazy(() => import("../pages/providers/ProvidersPage"));

export interface AppRouteConfigItem {
  path: string;
  element: React.ReactNode;
  isPublicRoute?: boolean;
  userTypeRedirect?: string;
  requireAuth?: boolean;
  requiredUserType?: "user" | "provider" | string;
  signInMessage?: string;
}

export interface RouteGroups {
  public: AppRouteConfigItem[];
  publicWithAuth: AppRouteConfigItem[];
  auth: AppRouteConfigItem[];
  userProtected: AppRouteConfigItem[];
  providerProtected: AppRouteConfigItem[];
}

/**
 * Route configuration organized by category
 */
export const routeConfig: RouteGroups = {
  // Public routes (no authentication required)
  public: [
    {
      path: ROUTES.HOME,
      element: <Home />,
    },
    {
      path: ROUTES.HOME_PAGE,
      element: <Home />,
    },
    {
      path: ROUTES.GET_STARTED,
      element: <GetStartedPage />,
    },
    {
      path: ROUTES.DATA_DELETION,
      element: <DataDeletionPage />,
    },
    {
      path: ROUTES.PRIVACY_POLICY_USER,
      element: <UserPrivacyPolicyPage />,
    },
    {
      path: ROUTES.PRIVACY_POLICY_PROVIDER,
      element: <ProviderPrivacyPolicyPage />,
    },
    {
      path: ROUTES.TERMS_CONDITIONS,
      element: <TermsConditionsPage />,
    },
    {
      path: ROUTES.HELP_CENTER,
      element: <HelpCenterPage />,
    },
    {
      path: ROUTES.PROVIDERS,
      element: <ProvidersPage />,
    },
  ],

  publicWithAuth: [],
  auth: [],
  userProtected: [],
  providerProtected: [],
};

/**
 * Get all routes as a flat array for React Router
 */
export const getAllRoutes = (): AppRouteConfigItem[] => {
  return [
    ...routeConfig.public,
    ...routeConfig.publicWithAuth,
    ...routeConfig.auth,
    ...routeConfig.userProtected,
    ...routeConfig.providerProtected,
  ];
};
